import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleDown,
  faAngleUp,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { Modal, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const ManagePoiExternalLink = ({
  poiExternalLink,
  handleDelete,
  handleRankingUpdate,
}) => {
  const { t } = useTranslation()
  const [showConfirmation, setShowConfirmation] = useState(false)

  const handleTrashClick = () => {
    setShowConfirmation(true)
  }

  const handleCloseConfirmation = () => {
    setShowConfirmation(false)
  }

  const handleConfirmDelete = () => {
    handleDelete(poiExternalLink.id)
    setShowConfirmation(false)
  }

  const handleRanking = (direction) => {
    handleRankingUpdate(direction, poiExternalLink.id)
  }

  const originalLinkText = poiExternalLink.externalLink.urlFr
  const truncatedLinkText =
    originalLinkText.length > 35
      ? `${originalLinkText.substring(0, 32)}...`
      : originalLinkText

  return (
    <div className="link-item green-frame">
      <p>
        {poiExternalLink.externalLink.labelFr}:{' '}
        <a
          href={poiExternalLink.externalLink.urlFr}
          style={{ marginLeft: '2px' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {truncatedLinkText}
        </a>
        <span>
          <Button
            variant="primary"
            className="btn btn-primary btn-sm margin-left-20"
            onClick={handleTrashClick}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
          <Button
            variant="primary"
            className="btn-sm"
            style={{ marginLeft: '10px' }}
            onClick={() => handleRanking('up')}
          >
            <FontAwesomeIcon icon={faAngleUp} />
          </Button>
          <Button
            variant="primary"
            className="btn-sm"
            style={{ marginLeft: '10px' }}
            onClick={() => handleRanking('down')}
          >
            <FontAwesomeIcon icon={faAngleDown} />
          </Button>
        </span>
      </p>
      <Modal show={showConfirmation} onHide={handleCloseConfirmation}>
        <Modal.Header closeButton>
          <Modal.Title>{t('CONFIRM_DELETE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('CONFIRM_DELETE_MESSAGE')}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            {t('CANCEL')}
          </Button>
          <Button variant="primary" onClick={handleConfirmDelete}>
            {t('CONFIRM')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default ManagePoiExternalLink
